<span>
  <img [src]="icons" width="50" height="50" />
</span>
